import React from "react";
import { Link } from "gatsby";
import "./style.scss";
import "./columns.scss";

const Navbar = () => (
  <div className="hero-head sticky">
    <div className="columns is-hidden-mobile is-marginless heading has-text-weight-bold">
      <div className="column left">
        <Link to="/" className="navbar-item has-text-danger">
          Inicio
        </Link>
        
      </div>
      <div className="column center">
        <Link to="/contacto" className="navbar-item has-text-white">
        ¡AGENDA UNA CITA YA!
        </Link>

      </div>
      <div className="column right">

      </div>
    </div>
    <div className="columns is-hidden-desktop is-mobile is-marginless heading has-text-weight-bold">
      <div className="column left">
        <Link to="/" className="navbar-item has-text-danger">
          Inicio
        </Link>
      </div>
      <div className="column center"></div>
      <div className="column right">

        <Link to="/contacto" className="navbar-item has-text-white">
        ¡AGENDA UNA CITA YA!
        </Link>
      </div>
    </div>
  </div>
);

export default Navbar;
